import {Component, OnInit, ViewChild} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import {PositionService} from '../services/position.service';
import {DeviceService} from '../services/device.service';
import {UserService} from '../services/user.service';
import {Message} from 'primeng/primeng';
import {AddressService} from '../services/address.service';
import {Table} from 'primeng/components/table/table';
import * as XLSX from 'xlsx';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-summary-infranctions-by-day-report',
    templateUrl: './summary-infranctions-by-day-report.component.html',
    styleUrls: ['./summary-infranctions-by-day-report.component.css']
})
export class SummaryInfranctionsByDayReportComponent implements OnInit {
    groupBy: String;
    devices: SelectItem[];
    dateOptions: SelectItem[];
    dateOption: any;
    idDevice: String;
    disabledInitialDate: boolean;
    disabledFinalDate: boolean;
    startDate: Date;
    endDate: Date;
    msgs: Message[] = [];
    blockedDocument: boolean = false;
    cols: any[];
    maxDays: number = 35;
    devicesReport: any[];

    @ViewChild('dt') table: Table;

    constructor(private positionService: PositionService, private deviceService: DeviceService,
                private userService: UserService, private addressService: AddressService) {
    }

    ngOnInit() {
        this.cols = [
            {field: 'name', header: 'NOMBRE'},
            {field: 'keyring', header: 'LLAVERO'},
            {field: 'driverName', header: 'CONDUCTOR'},
            {field: 'from', header: 'DESDE'},
            {field: 'to', header: 'HASTA'},
            {field: 'durationOn', header: 'HORAS CONDUCCIÓN'},
            {field: 'distance', header: 'DISTANCIA (km)'},
            {field: 'averageSpeed', header: 'VELOCIDAD PROMEDIO (km/hr)'},
            {field: 'maximumSpeed', header: 'VELOCIDAD MAXIMA (km/hr)'},
            {field: 'overSpeed', header: 'EXCESOS DE VELOCIDAD'},
            {field: 'hardBraking', header: 'FRENADO BRUSCO'},
            {field: 'hardAcceleration', header: 'ACELERACION BRUSCA'}
        ];
        this.dateOptions = [
            {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
            {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
            {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
            {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
        ];
        this.devices = [];
        this.devices.push({label: 'Todos', value: null});
        this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
            let response: any = data;
            response.devices.forEach(item => {
                this.devices.push({label: item.name, value: item.idDevice});
            });
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
        this.dateOption = '7';
        this.groupBy = '';
        this.changeDate();
    }

    changeDate() {
        this.disabledInitialDate = true;
        this.disabledFinalDate = true;
        if (this.dateOption == 'T') {
            this.startDate = new Date();
            this.endDate = new Date();
            this.startDate.setHours(0, 0, 0);
            this.endDate.setHours(23, 59, 59);
        } else if (this.dateOption == 'Y') {
            this.startDate = new Date();
            this.endDate = new Date();
            this.startDate.setDate(this.startDate.getDate() - 1);
            this.startDate.setHours(0, 0, 0);
            this.endDate.setDate(this.endDate.getDate() - 1);
            this.endDate.setHours(23, 59, 59);
        } else if (this.dateOption == '7') {
            this.startDate = new Date();
            this.endDate = new Date();
            this.startDate.setDate(this.startDate.getDate() - 6);
            this.startDate.setHours(0, 0, 0);
            this.endDate.setHours(23, 59, 59);
        } else {
            this.disabledInitialDate = false;
            this.disabledFinalDate = false;
        }
    }

    diferenciaEntreFechasEnDias(a: Date, b: Date): number {
        return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar() {
        if (this.table) {
            this.table.first = 1;
        }

        if (this.diferenciaEntreFechasEnDias(this.startDate, this.endDate) > this.maxDays) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'El rango de fechas no debe exceder los ' + this.maxDays + ' dias'
            }];
            return;
        }
        if (this.startDate >= this.endDate) {
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'La fecha final debe ser superior a la fecha inicial'
            }];
            return;
        }

        this.blockedDocument = true;
        if (this.idDevice == null) {
            this.deviceService.findByUser(this.userService.userLoged.idUser).then(data => {
                let response: any = data;
                if (response.status === 'OK') {
                    this.devicesReport = [...response.devices];
                    this.devicesReport.forEach(device => {
                        device.fileName = 'Movimientos_Diarios_' + device.name + '_' + this.startDate.toLocaleString() + '_' + this.endDate.toLocaleString();
                        device.loading = true;
                        this.positionService.getSummaryInfractionsByDay(device.idDevice, this.startDate, this.endDate).then(data => {
                            let response: any = data;
                            if (response.status == 'OK') {
                                device.records = [...response.records];
                                device.totalDurationOn = response.totalDurationOn;
                                device.totalDistance = response.totalDistance;
                                device.totalOverSpeed = response.totalOverSpeed;
                                device.totalHardBraking = response.totalHardBraking;
                                device.totalHardAcceleration = response.totalHardAcceleration;
                                device.records.forEach(record => {
                                    record.averageSpeed = record.averageSpeed.toFixed(2);
                                    record.maximumSpeed = record.maximumSpeed.toFixed(2);
                                    record.distance = record.distance.toFixed(2);
                                    record.timeOnTotal += record.timeOn;
                                });
                            } else {
                                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
                            }
                            device.loading = false;
                        }).catch(err => {
                            device.loading = false;
                            console.log(err);
                            this.msgs = [{
                                severity: 'error',
                                summary: 'ERROR',
                                detail: 'Existe algun problema con la conexión al servidor'
                            }];
                        });
                    });
                } else {
                    this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
                }
                this.blockedDocument = false;
            }).catch(err => {
                this.blockedDocument = false;
                console.log(err);
                this.msgs = [{
                    severity: 'error',
                    summary: 'ERROR',
                    detail: 'Existe algun problema con la conexión al servidor'
                }];
                this.blockedDocument = false;
            });
        } else {
            let deviceReport: any = {
                idDevice: this.idDevice,
                loading: true,
                fileName: 'Infracciones_por_Día_' + this.devices.find(device => device.value == this.idDevice).label
            };
            this.devicesReport = [deviceReport];
            this.positionService.getSummaryInfractionsByDay(this.idDevice, this.startDate, this.endDate).then(data => {
                let response: any = data;
                if (response.status == 'OK') {
                    deviceReport.records = [...response.records];
                    deviceReport.totalDurationOn = response.totalDurationOn;
                    deviceReport.totalDistance = response.totalDistance;
                    deviceReport.totalOverSpeed = response.totalOverSpeed;
                    deviceReport.totalHardBraking = response.totalHardBraking;
                    deviceReport.totalHardAcceleration = response.totalHardAcceleration;
                    deviceReport.records.forEach(record => {
                        record.averageSpeed = record.averageSpeed.toFixed(2);
                        record.maximumSpeed = record.maximumSpeed.toFixed(2);
                        record.distance = record.distance.toFixed(2);
                        record.timeOnTotal += record.timeOn;
                    });
                    deviceReport.loading = false;
                    this.devicesReport = [deviceReport];
                } else {
                    this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
                }
                this.blockedDocument = false;
            }).catch(err => {
                console.log(err);
                this.msgs = [{
                    severity: 'error',
                    summary: 'ERROR',
                    detail: 'Existe algun problema con la conexión al servidor'
                }];
                this.blockedDocument = false;
            });
        }
    }

    exportXLS(deviceReport: any) {
        let records = [];
        deviceReport.records.forEach(item => {
            let data = {};
            this.cols.forEach(col => {
                data[col.header] = item[col.field];
            });
            data[''] = {f: '=HYPERLINK("' + environment.reportsEndPoint + 'generateKMLTravel?idDevice=' + deviceReport.idDevice + '&startDate=' + new Date(item.startDate).toISOString() + '&endDate=' + new Date(item.endDate).toISOString() + '","Ver Recorrido")'};
            records.push(data);
        });

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
        const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        XLSX.writeFile(workbook, deviceReport.fileName + '.xlsx');
    }

    downloadKML(deviceReport: any, record: any) {
        console.log(environment.kmlURL + 'generateKMLTravel?idDevice=' + deviceReport.idDevice + '&startDate=' + new Date(record.startDate).toISOString() + '&endDate=' + new Date(record.endDate).toISOString());
        window.open(environment.kmlURL + 'generateKMLTravel?idDevice=' + deviceReport.idDevice + '&startDate=' + new Date(record.startDate).toISOString() + '&endDate=' + new Date(record.endDate).toISOString(), '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/app/summary-infranctions-by-day-report/summary-infranctions-by-day-report.component.ts